import { Building2 } from "lucide-react";
import { Carte, Indisponible, Ligne, isErreur } from "./shared";

const MODES = { bio: "Agriculture biologique", conventionnel: "Conventionnel" };

export default function ExploitationCard({ data }) {
  return (
    <Carte titre="Exploitation" numero="1" icon={Building2} testId="fiche-exploitation">
      {isErreur(data) ? <Indisponible /> : (
        <>
          {data.masque ? (
            <p className="text-xs text-gray-500 pb-1">Raison sociale, SIRET, PACAGE et propriétaire masqués.</p>
          ) : (
            <>
              <Ligne label="Raison sociale" v={data.raison_sociale} />
              <Ligne label="SIRET" v={data.siret} />
              <Ligne label="PACAGE" v={data.pacage} />
            </>
          )}
          <Ligne label="Mode de production" v={data.mode_production} format={(m) => MODES[m] || m} />
          {!data.masque && <Ligne label="Propriétaire" v={data.proprietaire} />}
          <Ligne label="Collaborateurs" v={data.nb_collaborateurs} />
        </>
      )}
    </Carte>
  );
}
